import React, { useState } from 'react';
import {
    Toolbar,
    Typography,
    Button,
    Stack,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import ModelDeleteSelectedItems from '../Models/ModelDeleteSelectedItems';

const TableBulkToolbar = ({
    selectedCount,
    onBulkDelete,
    onBulkRestore,
    isBulkDeleting,
    isBulkRestoring = false,
    bulkDeleteDisabled = false,
    bulkRestoreDisabled = false,
}) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';
    const isArabic = lng === 'ar';

    const [confirmOpen, setConfirmOpen] = useState(false);

    if (!selectedCount || (!onBulkDelete && !onBulkRestore)) return null;

    const handleOpenConfirm = () => setConfirmOpen(true);

    const handleCloseConfirm = () => {
        if (isBulkDeleting) return;
        setConfirmOpen(false);
    };

    const handleConfirmDelete = async () => {
        await onBulkDelete();
        setConfirmOpen(false);
    };

    return (
        <>
            <Toolbar
                sx={{
                    px: 2.5,
                    py: 1,
                    bgcolor: isDark ? '#111827' : '#E3F2FD',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: (t) => `1px solid ${t.palette.divider}`,
                }}
            >
                <Typography
                    sx={{ flex: '1 1 50%' }}
                    color="inherit"
                    variant="subtitle2"
                    component="div"
                >
                    {isArabic
                        ? `تم اختيار ${selectedCount}`
                        : `${selectedCount} selected`}
                </Typography>

                <Stack direction="row" sx={{ gap: 2 }}>
                    {onBulkRestore && (
                        <Button
                            variant="contained"
                            color="success"
                            size="small"
                            onClick={onBulkRestore}
                            disabled={isBulkRestoring || bulkRestoreDisabled}
                        >
                            {isBulkRestoring
                                ? isArabic ? 'جاري الاسترداد...' : 'Restoring...'
                                : isArabic ? 'استرداد المحدد' : 'Restore selected'}
                        </Button>
                    )}

                    {onBulkDelete && (
                        <Button
                            variant="contained"
                            color="error"
                            size="small"
                            onClick={handleOpenConfirm}
                            disabled={isBulkDeleting || bulkDeleteDisabled}
                            title={bulkDeleteDisabled ? (isArabic ? "لا تملك صلاحية حذف المحدد" : "No bulk delete permission") : ""}
                        >
                            {isBulkDeleting
                                ? isArabic ? 'جاري الحذف...' : 'Deleting...'
                                : isArabic ? 'حذف المحدد' : 'Delete selected'}
                        </Button>
                    )}
                </Stack>
            </Toolbar>

            {onBulkDelete && (
                <ModelDeleteSelectedItems
                    confirmOpen={confirmOpen}
                    handleCloseConfirm={handleCloseConfirm}
                    isArabic={isArabic}
                    selectedCount={selectedCount}
                    isBulkDeleting={isBulkDeleting}
                    handleConfirmDelete={handleConfirmDelete}
                />
            )}
        </>
    );
};

export default TableBulkToolbar;
